import MainLayout from "@/components/layout/company/MainLayout.vue";
// import Pagination from "laravel-vue-pagination";
import axios from "axios";
import { ConvertNumService } from "@/assets/js/convertNumberService.js";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';

const convertNumberService = new ConvertNumService();

export default {
    name: "jobPostCategory",

    components: {
        MainLayout,
        // Pagination,
        AdvancedLaravelVuePaginate
    },

    data() {
        return {
            categoryList: {
                data: []
            },
            isLoading: true,
            keyword: {
                search_name: ""
            },
            searchTimeout: null,
            page_status: false,
            total: ""
        };
    },

    methods: {
        getCategoryInfo(page = 1) {
            this.isLoading = true;
            axios.get("/category/info?page=" + page)
                .then(response => {
                    this.categoryList = response.data;
                    const totalCount = (this.categoryList && this.categoryList.total != null) ? this.categoryList.total : 0;
                    this.total = convertNumberService.convertEng2Mm(totalCount.toString());
                })
                .catch(error => {
                    console.log("Category Info API Error", error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        searchCategory(page = 1) {
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
                this.searchTimeout = null;
            }
            this.isLoading = true;

            var request = {
                params: {
                    search_name: this.keyword.search_name
                }
            };

            axios.get("/applicant/search/categoryresult?page=" + page, request)
                .then(response => {
                    this.page_status = true;
                    this.categoryList = response.data;
                    const totalCount = (this.categoryList && this.categoryList.total != null) ? this.categoryList.total : 0;
                    this.total = convertNumberService.convertEng2Mm(totalCount.toString());
                })
                .catch(error => {
                    console.log("Category Search API Error", error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        debouncedSearchCategory() {
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
            }
            this.searchTimeout = setTimeout(() => {
                this.searchCategory(1);
            }, 300);
        },

        clearAllFilters() {
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
                this.searchTimeout = null;
            }
            this.keyword.search_name = "";
            this.page_status = false;
            this.getCategoryInfo(1);
        },
    },

    mounted() {
        this.getCategoryInfo();
    },

    beforeDestroy() {
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = null;
        }
    }
};